import React, {useEffect} from 'react';
import {RatingLeague} from "@/entities/rating/ui/RatingLeague";
import {RatingTabs} from "@/entities/rating/ui/RatingTabs";
import {RatingLists} from "@/entities/rating/ui/RatingLists";
import {useStore} from "@/app/providers/StoreProvider";
import {Loading} from "@/shared/ui/Loading";

export const RatingPage = () => {

    const {ratingStore} = useStore();

    const {loading} = ratingStore;

    useEffect(()=>{
        return () => {
            ratingStore.resetRating();
        }
    },[])

    if(loading) return <Loading />;
    return (
        <div className='rating-page'>
            <div className="container">
                <RatingLeague/>
                <RatingTabs/>
                <RatingLists/>
            </div>
        </div>
    );
};
